// extracted by mini-css-extract-plugin
export default {"entertainingAttributes":"entertainingAttributes___tNE0V"};